import { paynowreport } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const PayNowReportAPIs = {

    GetPayNowReport: async function (reportDate, cancel = false){
        //reportDate must be yyyy-MM-dd
        const response = await paynowreport.request({
            url: `payment-workflow?date=${reportDate}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_PAYNOW_REPORT_KEY
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    PostPayNowReport: async function (postJSON, cancel = false){
        console.log('Pay Now base URL: ', process.env.REACT_APP_PAYNOW_REPORT_URL)
        const response = await paynowreport.request({
            url: 'payment-workflow',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_PAYNOW_REPORT_KEY,
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    

    
}
const cancelAPIObject = defineCancelApiObject(PayNowReportAPIs)